import { SET_STEPS_COMPLETED } from 'root/src/client/logic/app/actionIds'

export default stepsCompleted => ({
	type: SET_STEPS_COMPLETED,
	payload: { stepsCompleted },
})
